import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** Browser-level online/offline banner; removed from the DOM when online. */
export function OfflineIndicator() {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 inset-x-0 z-50 bg-warning text-warning-foreground py-1.5 px-4 text-sm flex items-center justify-center gap-2 shadow-md"
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      <span>Нет соединения. Ответы сохраняются на сервере — продолжите, когда связь вернётся.</span>
    </div>
  );
}
